export default "__VITE_ASSET__DCScjK8c__"